import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { openModal, stockGroupCreate, stockGroupList, closeModal } from '../../../../../redux/actions/action-creator';
import { toast } from 'react-toastify';
import FormData from 'form-data';
import MasterCreationFooter from '../../../../../components/Footer/Master_Footer/MasterCreationFooter';
import Form from '../../../../../components/Form/Form';
import { yes_no_array, nature_of_group_arrya, applicable_not_applicable_array } from '../../../../../components/Dummi_Data';
import { prepareFormData, useFormHandler } from '../../../../../components/Custom_Hooks/useFormHandler';
import useClickOutside from '../../../../../components/Custom_Hooks/useClickOutsSide';
import { useInputAction } from '../../../../../components/Custom_Hooks/useInputAction';
import InputField from '../../../../../components/Input/InputField';
import DropdownLayout_1 from '../../../../../components/Dropdown/DropdownLayout_1';
import { usePermission } from '../../../../../hooks/usePermission';

const StockGroup = ({ title, closeModal_sec }) => {

  const dispatch = useDispatch();

  const [nameInput, setNameInput] = useState(null)
  const { stock_group_data = null } = useSelector(state => state.common);
  const { userData = null } = useSelector(state => state.auth);
  const modal_state = useSelector(state => state.common.modal_state);

  //const memoizedStockGroupData = useMemo(() => stock_group_data, [stock_group_data]);

  const { add, view } = usePermission('Masters', 'Stock Groups');

  const initialState = {
    name: '',
    alias_name: '',
    under: 'Primary',
    stock_group_under_id: 'Primary',
    qty_items_added: '',

    is_gst_applicable: 'Applicable',

    HSN_SAC_details: 'As per Company/Stock Group',
    HSN_SAC: '',
    description: '',

    GST_rate_details: 'As per Company/Stock Group',
    source_details: 'Not Applicable',
    description: '',
    taxability_type: '',
    IGST_rate: '0',
    CGST_rate: '0',
    SGST_UTGST_rate: '0',
    cess_validation: 'Not Applicable',
    cess_rate: '0',
    application_of_reverse: 'No',
    eligible_tax_credit: 'No',
    company_id: userData?.id
  }
  const [data, setData] = useState(initialState);
  const modalStateRef = useRef(modal_state);

  useEffect(() => {
    modalStateRef.current = modal_state;
  }, [modal_state]);

  const inputRefs = {
    name: useRef(null),
    alias_name: useRef(null),
    stock_group_under_id: useRef(null),
  };

  function getCurrentInputRef(name) {
    return inputRefs[name] || null;
  }

  const inputFields = [
    { label: 'Name', name: 'name', type: 'text', isRequired: true, },
    { label: '(alise)', name: 'alias_name', type: 'text', isRequired: false, },
    { label: 'under', name: 'stock_group_under_id', type: 'text', isRequired: true, },
  ];

  const cleanString = (str) => str.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
  const validations = {
    name: (value) => value.trim() !== "",
    alias_name: (value) => value.trim() !== "",
    stock_group_under_id: (value) => stock_group_data.some(item => cleanString(item.name).toLowerCase()?.includes(cleanString(value).toLowerCase())),
  };

  const refs = Object.keys(inputRefs).reduce((acc, name) => {
    acc[name] = {
      onFocus: () => {
        const ref = getCurrentInputRef(name);
        if (ref) {
          setNameInput(ref)
          ref?.current?.setSelectionRange(0, ref?.current?.value?.length)
        };
        if (name === 'stock_group_under_id') {
          dispatch(openModal(name))
        }
      },
      onBlur: (value) => {
        if (name === 'name') {
          if (!value.trim() && submitConfirmRef.current !== 'Quit') {
            getCurrentInputRef(name)?.current?.focus();
          }
        }
        if (name === 'stock_group_under_id') {
          dispatch(closeModal(name))
        }
      },
    };
    return acc;
  }, {});


  const validateForm = () => {
    const requiredFields = [
      { field: 'name', message: 'Required Name Field' },
      { field: 'stock_group_under_id', message: 'Required under Field' },
    ]

    for (let { field, message } of requiredFields) {
      if (!data?.[field]) {
        toast.error(message, {
          position: toast.POSITION.TOP_CENTER,
        });
        setSubmitConfirm('');
        getCurrentInputRef(field)?.current?.focus();
        return false;
      }
    }
    return true;
  };

  // Function to reset form fields-----------------------------------------
  const resetForm = () => {
    setData(initialState)
  };

  const { handleChange, handleFocus, handleBlur, handleKeyDown, setSubmitConfirm, submitConfirm, handleDropdownClick } = useInputAction({
    data,
    setData,
    validations,
    refs,
    check_dropdown: modal_state?.stock_group_under_id,
    inputRefs,
  });

  const submitConfirmRef = useRef(submitConfirm);
  useEffect(() => {
    submitConfirmRef.current = submitConfirm;
  }, [submitConfirm]);

  const { handleSubmit, loading, handleFocusReset } = useFormHandler({
    validateForm,
    prepareFormData: () => prepareFormData(data),
    submitForm: (data) => dispatch(stockGroupCreate(data)),
    shortcuts: [
      {
        key: 'a',
        ctrlKey: true,
        action: () => handleSubmit(new Event('submit')),
      },
    ],
    resetForm,
    first_ref: inputRefs?.name,
    closeModal: closeModal_sec,
    setSubmitConfirm,
    submitConfirm
  });

  useEffect(() => {
    handleFocusReset();
  }, []);

  useEffect(() => {
    const formData = new FormData();
    formData.append('company_id', userData?.id)
    dispatch(stockGroupList(formData)).catch(err => console.error("Error loading stock groups:", err))
  }, [submitConfirm])

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === 'Escape') {
        if (submitConfirmRef.current) {
          event.preventDefault();
          event.stopImmediatePropagation();
          handleFocusReset();
          return;
        }
        const activeModals = Object.keys(modalStateRef.current || {}).filter(key => modalStateRef.current[key]);
        const closableModals = ['stock_group_under_id'];

        const openClosableModals = activeModals.filter(modal => closableModals.includes(modal));
        if (openClosableModals?.length > 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          openClosableModals.forEach((modal) => {
            dispatch(closeModal(modal));
          })
        } else {
          event.preventDefault();
          event.stopImmediatePropagation();
          submitConfirmRef.current = 'Quit';
          setSubmitConfirm('Quit');
          document.activeElement?.blur();
        }
      }
    };
    window.addEventListener('keydown', handleKeyPress, true);
    return () => {
      window.removeEventListener('keydown', handleKeyPress, true);
    };
  }, [dispatch, inputRefs, setSubmitConfirm, handleFocusReset]);


  const handleClickOutside = (event) => {
    if (nameInput?.current) {
      event.preventDefault();
      nameInput.current.focus();
    }
  };

  const handleClickInside = (event) => {
    let clickedElement = event.target;
    if (clickedElement?.tagName &&
      (clickedElement?.tagName.toLowerCase() === 'input' ||
        clickedElement?.tagName.toLowerCase() === 'textarea')) {
      clickedElement.focus();
    }
  };

  useClickOutside(nameInput, handleClickOutside, handleClickInside);

  if (!view || !add) {
    if (submitConfirm === 'Quit') {
      setTimeout(() => {
        if (closeModal_sec) {
          closeModal_sec();
        } else {
          window.history.back();
        }
      }, 0);
    }
    return (
      <div className="d-flex justify-content-center align-items-center h-100" style={{ minHeight: '80vh' }}>
        <h3>You do not have permission to access this page.</h3>
      </div>
    );
  }

  return (
    <Form
      handleSubmit={handleSubmit}
      handleKeyDown={handleKeyDown}
      submitConfirm={submitConfirm}
      handleFocusReset={handleFocusReset}
      title={title || 'Stock Group Creation'}
      loading={loading}
      col='col-5'
      Footer={MasterCreationFooter}
    >
      <div className='row p-0 ps-2 m-0 mb-1'>
        {inputFields?.map(({ label, name, type, value, ref, isRequired }, index) => (
          <InputField
            key={index}
            lable={label}
            type={type}
            name={name}
            value={data[name]}
            handleChange={handleChange}
            handleBlur={handleBlur}
            handleFocus={handleFocus}
            isRequired={isRequired}
            ref={inputRefs[name]}
          />
        ))}
        {
          modal_state?.stock_group_under_id ?
            <DropdownLayout_1
              title='List of Stock Group'
              state={modal_state?.stock_group_under_id}
              data={data}
              setData={setData}
              input_value={data?.stock_group_under_id}
              input_key='stock_group_under_id'
              input_id='under'
              rawData={stock_group_data}
              ref={inputRefs?.stock_group_under_id}
              inputRefs={inputRefs}
              setSubmitConfirm={setSubmitConfirm}
              handleDropdownClick={handleDropdownClick}
            /> : null}
      </div>
    </Form>
  )
}

export default StockGroup
